import { render, staticRenderFns } from "./register-mcheckBox.vue?vue&type=template&id=6a026d0d&scoped=true&"
import script from "./register-mcheckBox.vue?vue&type=script&lang=js&"
export * from "./register-mcheckBox.vue?vue&type=script&lang=js&"
import style0 from "./register-mcheckBox.vue?vue&type=style&index=0&id=6a026d0d&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a026d0d",
  null
  
)

export default component.exports